import { render, staticRenderFns } from "./tour.vue?vue&type=template&id=5a0398f8&scoped=true&"
import script from "./tour.vue?vue&type=script&lang=js&"
export * from "./tour.vue?vue&type=script&lang=js&"
import style0 from "./tour.vue?vue&type=style&index=0&id=5a0398f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0398f8",
  null
  
)

export default component.exports